import axios from 'axios';
export default class FirebaseApi {
  async getTerm() {
    const url = process.env.VUE_APP_FIREBASE_URL;
    const result = await axios.get(url);

    return result.data;
  }
}
